/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import {
  Divider,
} from '@material-ui/core';
import { useLocation, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  CommonPagination,
  ScreenContainer,
} from '../../CommonComponents';
import {
  getAllSites,
  getSitesDataByEstimateId,
  updatePrimaryQuery,
} from '../../redux/actions/sites';
import SitesFilter from '../../CommonComponents/SitesFilter/SitesFilter';
import PrimaryFilters from '../../CommonComponents/PrimaryFilters';
import FallbackCard from '../../CommonComponents/FallbackCard';
import { exportCompeteSiteReports, exportSites, importSites } from '../../redux/actions/common';
import ChangeDateTable from './ChangeDateTable';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const UpdateEndDate = ({
  getAllSitesAction,
  totalSitePages,
  updateQuery,
  primaryQuery,
  searchQuery,
  fetchSites,
}) => {
  const query = useQuery();
  const history = useHistory()
  const page = parseInt(query.get('page') || '1', 10);
  const [showSites, enableSites] = useState(false);
  const [selected, setSelected] = useState([]);
  const [checkBoxState, setCheckbox] = React.useState(true);

  useEffect(() => {
    const pno = query.get('page')
    if (showSites && pno) { getAllSitesAction(page, searchQuery, primaryQuery); }
  }, [query, getAllSitesAction, searchQuery, primaryQuery, showSites, page]);

  const fetchAllSite = (val) => {
    setSelected([]);
    setCheckbox(true);
    if (query.has('estimateId')) {
      query.set('estimateId', val)
    } else {
      query.append('estimateId', val)
    }
    query.delete('page')
    history.push('/change-end-date')
    updateQuery(query.toString())
    fetchSites(val);
    enableSites(true);
  }

  return (
    <ScreenContainer title="Change End Date">
      <PrimaryFilters
        visibleProduct
        visibleEstimate
        fetchFunction={fetchAllSite}
        location="allsites"
        showFetchButton
      />
      <br />
      {showSites
        ? (
          <>
            <SitesFilter currentLocation="change-end-date" setSelected={setSelected} />
            <div className="row">
              <Divider />
              <div className="col-12">
                <br />
                <ChangeDateTable
                  setSelected={setSelected}
                  selected={selected}
                  setCheckbox={setCheckbox}
                  checkBoxState={checkBoxState}
                />
                {totalSitePages > 1 ? (
                  <CommonPagination
                    baseUrl="assign-flex-date"
                    totalPages={totalSitePages}
                  />
                ) : null}
                <br />
                <br />
              </div>
            </div>
          </>
        )
        : <FallbackCard text="Fetch the sites to start" />}
    </ScreenContainer>
  );
};

const mapState = (state) => ({
  totalSitePages: state.sites.totalSitePages,
  searchQuery: state.sites.searchQuery,
  primaryQuery: state.sites.primaryQuery,
});

const mapActions = {
  getAllSitesAction: getAllSites,
  fetchSites: getSitesDataByEstimateId,
  updateQuery: updatePrimaryQuery,
  exportSite: exportSites,
  exportCompleteSites: exportCompeteSiteReports,
  importSite: importSites,
};

export default connect(mapState, mapActions)(UpdateEndDate);
